import { render, staticRenderFns } from "./ClientMessage.vue?vue&type=template&id=771ed060&scoped=true"
import script from "./ClientMessage.vue?vue&type=script&lang=ts"
export * from "./ClientMessage.vue?vue&type=script&lang=ts"
import style0 from "./ClientMessage.vue?vue&type=style&index=0&id=771ed060&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "771ed060",
  null
  
)

export default component.exports